import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';

export default class SurveysIndex {

  constructor() {}

  render() {
    ResearchFiltering();

    // Set submit and approval deadline fields from buttons
    $('#filtersModal .deadline-filter-buttons .btn').on('click', function() {
      const type = $(this).attr('data-type');
      const active = $(this).hasClass('active');
      const date = $(this).attr('data-date');
      const label = $(this).text().trim();

      // Set from field as today if selecting next week or month
      let from;
      if (label === 'Next week' || label === 'Next month') {
        from = new Date().toISOString().split('T')[0];
      } else if (label === 'Last Year') {
        const dateObj = date ? new Date(date) : null;
        const year = dateObj ? dateObj.getFullYear() : new Date().getFullYear() - 1;
        from = `${year}-01-01`;
      }

      if (active) {
        // Clear field
        if (type === 'submission') {
          $('#submission_deadline_from').val('').trigger('change');
          $('#submission_deadline_to').val('').trigger('change');
        } else if (type === 'approval') {
          $('#approval_deadline_from').val('').trigger('change');
          $('#approval_deadline_to').val('').trigger('change');
        } else if (type === 'data') {
          $('#data_from').val('').trigger('change');
          $('#data_to').val('').trigger('change');
        }
        return;
      }

      // Set field
      if (type === 'submission') {
        $('#submission_deadline_from').val(from).trigger('change');
        $('#submission_deadline_to').val(date).trigger('change');
      } else if (type === 'approval') {
        $('#approval_deadline_from').val(from).trigger('change');
        $('#approval_deadline_to').val(date).trigger('change');
      } else if (type === 'data') {
        $('#data_from').val(from).trigger('change');
        $('#data_to').val(date).trigger('change');
      }
    });

  }

}
